import React from "react";
import { useLocation } from "react-router-dom";

// Each new page fades in briefly (opacity only, so sticky/fixed bars don't move).
// Keyed by path: changing only the #section of a page does not fade. Off for reduced motion.
export default function PageFade({ children }) {
  const { pathname } = useLocation();
  return <div key={pathname} className="tf-page-in">{children}</div>;
}
